import { CANCELLED, COMPLETE_WITHOUT_CODE, INCOMPLETE_WITHOUT_CODE, } from "constants/status-codes";
export const setStatusVariant = (startedStatuses, status) => {
    if (status.includes(INCOMPLETE_WITHOUT_CODE))
        return "incomplete";
    if (status.includes(COMPLETE_WITHOUT_CODE))
        return "completed";
    if (status === CANCELLED)
        return "cancelled";
    if (startedStatuses.includes(status))
        return "started";
    return "normal";
};
